require('angular').module('oly.common')
    .directive('olyTooltip', [require('./tooltip.directive')])
    .directive('olyQuestionmarkTooltip', [require('./tooltip-questionmark.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/tooltip/index.js